export default "__VITE_ASSET__DKnfEOdT__"